import React, { useEffect, useState } from "react";

const noValue = "- Seleccionar -";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
  
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const Credito = ({ monto, plazo, simulacionCreditos }) => {
  
  const [credito, setCredito] = useState({});
  
  
  useEffect(() => {
    
    if (monto === noValue || plazo === noValue) {
      setCredito({ isNodata: true });
    } else {
      const montoNumber = parseFloat(monto);
      const plazoNumber = parseInt(plazo);
      const item = simulacionCreditos.find(k => {
        return k.monto === montoNumber && k.plazo_meses === plazoNumber;
      });
      
      console.log("xxx");
      setCredito({
        num_pagos: item.num_pagos,
        retencion: item.retencion,
        tasa_mensual: item.tasa_mensual,
        CAT: item.CAT
      });
    }
    
    
  }, [monto, plazo]);
  
  
  if (credito.isNodata) {
    return null;
  }
  
  return (
    <>
      <div className="has-text-center">
        La cantidad a pagar de manera quincenal serian:
      </div>
      <div className="has-text-center mtBig">
        <span className="labelPill">{credito.num_pagos}</span>
        pagos de
        <span className="labelPill">{formatter.format(credito.retencion)}</span>
      </div>
      <div className="has-text-center mtBig">
        Calculado a una tasa de interes mensual de:
        <strong className="ml">{credito.tasa_mensual} % </strong>
        mas IVA y un Costo Anual Total:
        <strong className="ml">{credito.CAT} %</strong>
      </div>
    
    </>
  
  
  );
};

export default Credito;